function Menu() {
  return (
    <div className="d-flex flex-column justify-content-center top-menu">
      <div className="row">
        <div className="center-block title-box">
          <div className="text-center">
            <span className="fw-bold small title-text text-uppercase">
              <a className="plain-link" href="https://www.um.org/umap2024/">
                UMAP 2024
              </a>
            </span>
          </div>
          <div className="text-center">
            <span className="fs-1 title-text text-uppercase">
              Collaborative Team Recommendation For Skilled Users
            </span>
          </div>
          <div className="text-center">
            <span className="fw-bold small title-text text-uppercase">
              Objectives, Techniques, and New Perspectives
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
